import { initMercadoPago, Wallet } from '@mercadopago/sdk-react'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { useTieneCuentaMPVinculada } from '../../hooks/useMercadoPago.js'
import { crearPreferencia } from '../../servicios/mercadoPagoService'
import * as usuarioService from '../../servicios/usuarioService'
import styles from './VincularMercadoPago.module.css'

export const PasarelaMP = ({ items }) => {
  const [preferenceId, setPreferenceId] = useState(null)
  const [empid, setEmpid] = useState('')
  const [cargando, setCargando] = useState(true)
  const { tieneCuentaVinculadaMP, respuesta } = useTieneCuentaMPVinculada(empid)

  const obtenerVendedor = async () => {
    const { data } = await usuarioService.buscarPorId(items.idVendedor)
    setEmpid(data.empid)
  }

  const obtenerPreferenceId = async () => {
    try {
      const itemsConEmpid = { ...items, empid }
      const { data } = await crearPreferencia(itemsConEmpid)
      initMercadoPago(data.body.publicKey)
      setPreferenceId(data.body.id)
    } catch (error) {
      const mensaje = `Ocurrió un error al crear la preferencia de pago en Mercado Pago.`
      toastErrorLog(error, mensaje, 'mercadoPago')
    }
  }
  useEffect(() => {
    if (!empid || respuesta === null) return
    !preferenceId && tieneCuentaVinculadaMP && obtenerPreferenceId()
    setCargando(false)
  }, [preferenceId, empid, tieneCuentaVinculadaMP, respuesta])

  useEffect(() => {
    obtenerVendedor()
  }, [items?.idVendedor])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '50px'
      }}
    >
      {cargando ? (
        <Spinner animation="border" />
      ) : preferenceId ? (
        <div style={{ width: '300px' }}>
          <Wallet initialization={{ preferenceId }} />
        </div>
      ) : tieneCuentaVinculadaMP ? (
        <Spinner animation="border" />
      ) : (
        <small className="warningMessage">
          <i className={`fa fa-exclamation-triangle ${styles.warningIcon}`} /> El vendedor no tiene
          una cuenta de Mercado Pago vinculada.
          <br />
          Comuníquese con él para continuar.
        </small>
      )}
    </div>
  )
}

PasarelaMP.propTypes = {
  items: PropTypes.object.isRequired
}
